import {
  Alert,
  AppBar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography
} from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { LoadingButton } from '@mui/lab';
import { Fragment, useEffect, useRef, useState } from 'react';
import request from '../../utils/request';
import SnackbarAlert from '../common/SnackbarAlert';
import loader from '../common/loader.gif';

const EndorsementListInsurerView = () => {
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const [isLoading, setLoading] = useState(false);
  const [decodedArray, setDecodedArray] = useState([]);
  const [viewFlag, setViewFlag] = useState(false);
  const [decision, setDecision] = useState(true);
  const [showOtpAlert, setOtpAlert] = useState(false);
  const [otpFromTextbox, setOtpFromTextbox] = useState(null);
  const [sendLoader, setSendLoader] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [otpSentMessage, setOtpSentMessage] = useState(null);
  const [showTimeRemaining, setShowTimeRemaining] = useState(false);
  const [seconds, setSeconds] = useState(null);
  const [status, setStatus] = useState(false);
  const [endorsementData, setEndorsementData] = useState(null);

  const [netPremium, setNetPremium] = useState(0);
  const [gstPercentage, setGstPercentage] = useState(
    parseFloat(
      endorsementData?.gst ??
      endorsementData?.insurancePolicy?.placementSlip?.gst ??
      0
    )
  );


  useEffect(() => {
    if (endorsementData) {
      formik.setFieldValue('gst',
        parseFloat(
          endorsementData?.gst ??
          endorsementData?.insurancePolicy?.placementSlip?.policyProduct?.gst ??
          0
        ))
    }

  }, [endorsementData])

  useEffect(() => {
    if (showTimeRemaining) {
      if (seconds > 0) {
        setTimeout(() => setSeconds(seconds - 1), 1000);
      } else {
        setOtpFromTextbox(null);
        setShowTimeRemaining(false);
      }
      setStatus(!status);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTimeRemaining, seconds]);

  const secondsToMinutes = (e) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const h = Math.floor(e / 3600)
      .toString()
      .padStart(2, '0'),
      m = Math.floor((e % 3600) / 60)
        .toString()
        .padStart(2, '0'),
      s = Math.floor(e % 60)
        .toString()
        .padStart(2, '0');

    return 'Your OTP will expire in : ' + m + ':' + s;
  };

  useEffect(() => {
    // const isContentLoaded = document.readyState === 'complete';

    if (performance.getEntriesByType('navigation')[0]['type'] === 'reload') {
      // Remove the last hash fragment from the URL
      const urlWithoutLastHash = window.location.href.replace(/#[^#]*$/, '');

      // Navigate to the modified URL
      // window.location.replace(urlWithoutLastHash);
      let urlArray = urlWithoutLastHash.split('/');
      let encodedString = urlArray[4];

      const decoded = atob(encodedString);
      setDecodedArray(JSON.parse(decoded));

    } else {
      let urlArray = window.location.href.split('/');
      let encodedString = urlArray[4];

      const decoded = atob(encodedString);
      setDecodedArray(JSON.parse(decoded));

    }

    setOtpAlert(true);
    //customerLoginOtp();
  }, []);

  useEffect(() => {
    if (decodedArray) {
      fetchEndorsement(decodedArray['endorsementIds']?.[0])
    }

  }, [decodedArray])

  const fetchEndorsement = (id) => {
    if (!id) {
      return;
    }

    request({
      url: `endorsement/getEndorsementById/${id}`,
      method: 'get'
    }).then(
      (response: any) => {

        setEndorsementData(response.data);
      },
      (error) => {

        console.log(error);
      }
    );
  };

  const customerLoginOtp = (type) => {

    setSendLoader(true);
    setOtpSentMessage(null);
    request({
      url: 'otp/insuranceOtpLogin',
      method: 'post',
      data: {
        userType: 'InsuranceCompanyContact',
        userId: decodedArray['branchContact']
      }
    })
      // eslint-disable-next-line
      .then((data) => {
        setSendLoader(false);
        setSeconds(60);
        setShowTimeRemaining(true);
        setOtpSentMessage(data['message']);
      })
      .catch(function (err) {
        setSendLoader(true);
        setLoading(false);
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
      });
  };
  console.log('decodedArray:', decodedArray);
  const verifyOtp = () => {
    if (otpFromTextbox === null) {
      setShowSnackBarAlert({
        status: true,
        type: 'error',
        message: 'Please enter the OTP'
      });
      return;
    }
    setSubmitLoader(true);
    request({
      url: 'otp/verifyOtp',
      method: 'post',
      data: {
        userType: 'InsuranceCompanyContact',
        userId: decodedArray['branchContact'],
        otp: otpFromTextbox
      }
    })
      // eslint-disable-next-line
      .then((data: any) => {
        if (data.status) {
          // setLoader(false);
          setViewFlag(true);
          setShowSnackBarAlert({
            status: true,
            type: 'success',
            message: data['message']
          });
          setOtpAlert(false);
        } else {
          // setLoader(false);
          setSubmitLoader(false);
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: data['message']
          });
          if (data?.message === 'OTP Expired') {
            setOtpFromTextbox(null);
          }
        }

        // getInsuranceComapany();
      })
      .catch(function (err) {
        // setLoader(false);
        setSubmitLoader(false);
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
        if (err?.message === 'OTP Expired') {
          setOtpFromTextbox(null);
        }
      });
  };

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  const componentRef = useRef();

  const premiumSchema = Yup.object().shape({
    premium: Yup.string().required('Premium is required').nullable(),
    premiumType: Yup.string().required('Premium Type is required').nullable(),
    gst: Yup.string().required('GST % is required'),
  });

  const handleSubmitPremium = (values?: any) => {
    request({
      url: `endorsement/submitPremium`,
      method: 'post',
      data: {
        id: decodedArray['endorsementIds'],
        premium: values?.premium,
        premiumType: values?.premiumType,
        gst: values.gst
      }
    })
      .then((response: any) => {
        setShowSnackBarAlert({
          status: true,
          type: 'success',
          message: response.message
        });
        setDecision(false);
      })
      .catch(function (err) {
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
      });
  };

  const formik = useFormik({
    initialValues: {
      premium: '0',
      premiumType:  endorsementData?.endorsementData?.type === 'Cancellation-Endorsement'?'REFUND':'PREMIUM_REQUIRED',
      gst: null
    },
    validationSchema: premiumSchema,
    onSubmit: async (values) => {
      if (values.gst >= 0 && values.gst != null) {
        handleSubmitPremium(values);
      }

    }
  });

  useEffect(() => {
    if (formik.values.premium && formik.values.gst >= 0) {
      const gstAmount = (parseFloat(formik.values.premium) * formik.values.gst) / 100;
      setNetPremium(parseFloat(formik.values.premium) + gstAmount);
    } else {
      setNetPremium(parseFloat(formik.values.premium)); // fallback if GST missing
    }
  }, [formik.values.premium, formik.values.gst]);

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      {viewFlag ? (
        <Container>
          <Grid item xs={12} style={{ minHeight: '10.5vh' }}>
            <AppBar>
              <Toolbar style={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  variant="h6"
                  component="div"
                  className="conformHead"
                >
                  Enter Premium Details
                </Typography>
              </Toolbar>
            </AppBar>
          </Grid>

          {isLoading ? (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <img
                        alt="loader"
                        src={loader}
                        className="loader"
                        width={100}
                        height={100}
                      />
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
          ) : (
            <>
              <div ref={componentRef}>
                <Paper
                  sx={{ mt: 2, p: 3, backgroundColor: '#fff' }}
                  elevation={3}
                >
                  <Card sx={{ marginTop: '2vh' }}>
                    <CardContent>
                      <form onSubmit={formik.handleSubmit}>
                        <Grid
                          container
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="stretch"
                          spacing={3}
                        >

                          <Grid item xs={12} md={4}>
                            <FormControl component="fieldset">
                              <FormLabel component="legend">
                                {
                                  <>
                                    Premium Type{' '}
                                    <Typography
                                      component="span"
                                      sx={{ color: 'red' }}
                                    >
                                      *
                                    </Typography>
                                  </>
                                }
                              </FormLabel>
                              <RadioGroup
                                row
                                name="premiumType"
                                value={formik.values.premiumType}
                                onChange={(e) => {
                                  formik.setValues({
                                    ...formik.values,
                                    premiumType: e.target.value,
                                    premium: '0'
                                  });
                                }}
                              >
                                <FormControlLabel
                                  value="PREMIUM_REQUIRED"
                                  control={<Radio />}
                                  label="Payment"
                                  disabled={endorsementData?.endorsementData?.type === 'Cancellation-Endorsement'}
                                />
                                <FormControlLabel
                                  value="REFUND"
                                  control={<Radio />}
                                  label="Refund"
                                />
                                <FormControlLabel
                                  value="NO_PREMIUM"
                                  control={<Radio />}
                                  label="No Premium"
                                  disabled={endorsementData?.endorsementData?.type === 'Cancellation-Endorsement'}
                                />
                              </RadioGroup>
                              <FormHelperText
                                error={
                                  formik.touched.premiumType &&
                                  Boolean(formik.errors.premiumType)
                                }
                              >
                                {formik.touched.premiumType &&
                                  formik.errors.premiumType
                                  ? formik.errors.premiumType
                                  : ''}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={3} mt={2}>
                            <TextField
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label={
                                <Fragment>
                                  Premium (Without GST){' '}
                                  <Typography component="span" sx={{ color: 'red' }}>
                                    *
                                  </Typography>
                                </Fragment>
                              }
                              sx={{ width: '100%' }}
                              size="small"
                              name="premium"
                              value={formik.values.premium}
                              onChange={(e) => {
                                const value = e.target.value;

                                // ✅ Allow only digits and one optional decimal point
                                if (/^\d*\.?\d*$/.test(value)) {
                                  formik.setFieldValue('premium', value);
                                }
                              }}
                              onKeyDown={(e) => {
                                // ✅ Block invalid characters
                                const invalidKeys = ['-', '+', 'e', 'E'];
                                if (invalidKeys.includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onBlur={formik.handleBlur}
                              error={formik.touched.premium && Boolean(formik.errors.premium)}
                              helperText={formik.touched.premium && formik.errors.premium}
                            />

                          </Grid>
                          <Grid item xs={2} mr={2} mt={2}>

                            <TextField
                              sx={{ width: '100%' }}
                              label={
                                <>
                                  GST %{' '}
                                  {formik.values.premiumType !== 'NO_PREMIUM' && (
                                    <Typography component="span" sx={{ color: 'red' }}>
                                      *
                                    </Typography>
                                  )}
                                </>
                              }
                              disabled={formik.values.premiumType === 'NO_PREMIUM'}
                              name="gst"
                              type="text"
                              value={
                                formik.values.gst !== null && formik.values.gst !== undefined
                                  ? String(formik.values.gst)
                                  : ''
                              }
                              onChange={(e) => {
                                const { value } = e.target;

                                // ✅ Allow digits, one dot, and up to 2 decimals
                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                  // keep as string while typing — don’t parse yet
                                  formik.setFieldValue('gst', value);
                                }
                              }}
                              onBlur={(e) => {
                                const val = e.target.value;
                                if (val !== '' && val !== null && val !== undefined) {
                                  const parsed = parseFloat(val);
                                  if (!isNaN(parsed)) {
                                    // ✅ round to 2 decimals and convert to number for calculations
                                    formik.setFieldValue('gst', Number(parsed.toFixed(2)));
                                  } else {
                                    formik.setFieldValue('gst', '');
                                  }
                                }
                                formik.handleBlur(e);
                              }}
                              size="small"
                              error={formik.touched.gst && Boolean(formik.errors.gst)}
                              helperText={formik.touched.gst && formik.errors.gst}
                            />



                          </Grid>
                          <Grid item xs={2} mr={2} mt={2}>

                            <TextField
                              sx={{ width: '100%' }}
                              label={
                                <>
                                  Net Premium {' '}
                                  {formik.values.premiumType !== 'NO_PREMIUM' ? (
                                    <Typography
                                      component="span"
                                      sx={{ color: 'red' }}
                                    >
                                      *
                                    </Typography>
                                  ) : null}
                                </>
                              }
                              disabled={true}
                              name="net_premium"
                              type="number"
                              value={netPremium?.toFixed(2)}
                              onChange={(e) => setNetPremium(parseFloat(e.target.value))}
                              size="small"
                            />
                          </Grid>
                        </Grid>
                      </form>
                    </CardContent>
                  </Card>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '2vh',
                    }}
                  >
                    {endorsementData?.status === 'Premium Received' ? (
                      <Box
                        sx={{
                          textAlign: 'center',
                          backgroundColor: '#e6f7e6',
                          padding: '16px',
                          borderRadius: '8px',
                          width: '100%',
                          maxWidth: '400px',
                          boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
                        }}
                      >
                        <Typography variant="subtitle1" color="success.main" fontWeight="bold">
                          Premium Received
                        </Typography>
                        <Typography variant="body2">
                          <strong>Premium:</strong> ₹{endorsementData?.premium?.toLocaleString() || 0}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Tax:</strong> ₹{endorsementData?.tax?.toLocaleString() || 0}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Total Premium:</strong> ₹{endorsementData?.totalPremium?.toLocaleString() || 0}
                        </Typography>
                      </Box>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => formik.handleSubmit()}
                        disabled={!decision}
                      >
                        Submit
                      </Button>
                    )}
                  </Box>

                </Paper>
              </div>
            </>
          )}
        </Container>
      ) : (
        <Dialog
          open={showOtpAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">OTP Verification</DialogTitle>
          <DialogContent>
            <Container maxWidth="sm">
              <FormControl variant="outlined" fullWidth>
                <TextField
                  type="text"
                  placeholder="Enter Your OTP Here..."
                  value={otpFromTextbox || ''}
                  onChange={(e) => {
                    setOtpFromTextbox(e.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <LoadingButton
                          loading={submitLoader || sendLoader}
                          variant="contained"
                          type="button"
                          onClick={() => {
                            if (showOtpAlert === true && !showTimeRemaining) {
                              customerLoginOtp('generate');
                            } else {
                              verifyOtp();
                            }
                          }}
                          disabled={
                            (!decodedArray['branchContact']) || (
                              seconds > 0 &&
                              seconds <= 60 &&
                              !otpFromTextbox?.length
                            )
                          }
                        >
                          {showOtpAlert === true && seconds === null
                            ? 'Send OTP'
                            : seconds === 0
                              ? 'Resend OTP'
                              : 'Verify OTP'}
                        </LoadingButton>
                      </InputAdornment>
                    )
                  }}
                />
              </FormControl>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12}>
                  {showTimeRemaining ? <>{secondsToMinutes(seconds)}</> : null}
                </Grid>
                <Grid item xs={12}>
                  {otpSentMessage ? (
                    <Alert severity="success">{otpSentMessage}</Alert>
                  ) : null}
                </Grid>
              </Grid>
            </Container>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
export default EndorsementListInsurerView;
